import React from 'react';
import Sidebar from './CustomComponents/Sidebar';
import LiveStatusChip from './Components/LiveStatusChip';
import { Outlet } from 'react-router-dom';

const CustomLayout = ({ children }) => {
  return (
    <div className="flex h-screen w-full max-w-full overflow-hidden bg-[var(--app-bg)] font-[Inter,system-ui,sans-serif] transition-colors duration-200">
      <Sidebar />
      <LiveStatusChip />
      <main className="main-comp min-w-0 flex-1 overflow-y-auto overflow-x-hidden pt-1.5 pb-3 px-3 md:px-4 bg-[var(--app-bg)] transition-colors duration-200">
        <Outlet />
        {children}
      </main>
    </div>
  );
};

export default CustomLayout;
